var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"zg-illustration"},[(_vm.illustration)?_c(_vm.illustration,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }